import axios from 'axios';
import {reportError} from './rollbar';

const base_url = process.env.API_BASE;//api

const _axios = axios.create({withCredentials: true});

// Rollbar groups items by message, so keep record ids out of it — a 500 on
// /property/edit/9 and on /property/edit/12 are the same bug, not two.
const normalizeUrl = function (url) {
  return String(url).split('?')[0].replace(/\/\d+(?=\/|$)/g, '/:id');
};

// 4xx is the server telling us the request was wrong (validation, expired session,
// not found) and the UI already surfaces those to the landlord. Only transport
// failures and server faults are bugs, so those are all we report.
const reportRequestFailure = function (method, url, error) {
  const status = error && error.response && error.response.status;
  if (status && status < 500) return;
  const path = normalizeUrl(url);
  reportError(
    status ? 'error' : 'warning',
    `API ${method} ${path} failed (${status || 'no response'})`,
    error,
    {api: {method, url, status: status || null}}
  );
};

const post = async function (url, params, setProgress) {

  const config = {
    onUploadProgress:
      setProgress
        ? function (progressEvent) {
          setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }
        : undefined,
    withCredentials: true
  }

  try {
    return (await _axios.post(base_url + url, params, config)).data;
  } catch (error) {
    reportRequestFailure('POST', url, error);
    throw (error.response && error.response.data) || error;
  }
};

const get = async function (url, params) {
  try {
    return (await _axios.get(base_url + url, {withCredentials: true, params})).data;
  } catch (error) {
    reportRequestFailure('GET', url, error);
    throw (error.response && error.response.data) || error;
  }
};

const patch = async function (url, params) {
  try {
    return (await _axios.patch(base_url + url, params, {withCredentials: true})).data;
  } catch (error) {
    reportRequestFailure('PATCH', url, error);
    throw (error.response && error.response.data) || error;
  }
};

export {get, post, patch, base_url};

export * from './userServices';
export * from './propertyServices';
export * from './visitServices';
export * from './dashboardServices';
export * from './platformServices';
